import { useQuery } from '@based/sdk/react'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { RegionalPageLayout } from '@app/pages/layout/RegionalPageLayout'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { getEntityPageStatus } from '@app/util/getEntityPageStatus'
import { NotFoundPage } from '@app/pages/error/NotFoundPage'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { regionTabs } from '@app/pages/discover/regions/constants'
import { KnowledgeHubModuleView } from '@app/pages/knowledge-hub/KnowledgeHubModule'

export type RegionalKnowledgeHubModulePageProps = {
  regionSlug: string
  itemId: string
}

export const RegionalKnowledgeHubModulePage = ({
  regionSlug,
  itemId,
}: RegionalKnowledgeHubModulePageProps) => {
  const t = useTranslations().app.knowledgeHubPage
  const regionQuery = useQuery('view-region', { slug: regionSlug })
  const region: RegionViewModel | undefined = regionQuery.data
  const regionPageStatus = getEntityPageStatus(regionQuery.loading, region)

  if (regionPageStatus === 'not-found') {
    return <NotFoundPage />
  }

  if (regionPageStatus === 'loading' || !region) {
    return (
      <PageLayout gap="2rem">
        <PageSeo />
        {t.loading}
      </PageLayout>
    )
  }

  return (
    <KnowledgeHubModuleView
      itemId={itemId}
      backPath={pages.regionPageNew(regionSlug, regionTabs.knowledgeHub)}
      renderReady={(body) => (
        <RegionalPageLayout
          region={region}
          tab={regionTabs.knowledgeHub}
          gap="0rem"
        >
          <PageSeo />
          {body}
        </RegionalPageLayout>
      )}
    />
  )
}
